import { render, staticRenderFns } from "./ModuleItemForm.vue?vue&type=template&id=2e436418&scoped=true&"
import script from "./ModuleItemForm.vue?vue&type=script&lang=ts&"
export * from "./ModuleItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleItemForm.vue?vue&type=style&index=0&id=2e436418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e436418",
  null
  
)

component.options.__file = "ModuleItemForm.vue"
export default component.exports